import { createStyles, makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) =>
  createStyles({
    back: {
      cursor: 'pointer',
      width: 'max-content',
      margin: 0,
      marginTop: theme.spacing(3),
    },
    backButton: {
      cursor: 'pointer',
      width: 'max-content',
      margin: 0,
      padding: 0,
      marginTop: theme.spacing(3),
    },
    backLink: {
      color: theme.palette.primary.main,
      fontWeight: +theme.typography.fontWeightMedium,
      fontSize: '1rem',
      lineHeight: '1.75rem',
    },
    backIcon: {
      fontSize: '1rem',
      margin: `0px ${theme.spacing()}px -3px 0px`,
      height: '1rem',
      transform: 'rotate(-180deg)',
      color: theme.palette.primary.main,
    },
    tabTitle: {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: theme.palette.grey[900],
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1rem',
      '& .Mui-selected': {
        color: 'white',
        backgroundColor: theme.palette.primary.main,
      },
    },
    errorTextCustom: {
      position: 'absolute',
      bottom: '-20px',
    },
    top: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },

    syncIcon: {
      marginRight: '0.5rem',
      paddingTop: '0.125rem',
    },
    syncText: {
      color: '#1D1F48',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    syncDisabled: {
      color: '#757575',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    syncSection: {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    syncSectionDisabled: {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'disabled',
    },
    syncContainer: {
      position: 'relative',
      paddingRight: '2rem',
      display: 'flex',
      justifyContent: 'center',
      marginTop: '1.5rem',
    },
    tooltipContainer: {
      height: theme.spacing(2),
      '& .MuiTooltip-tooltip, & .MuiTooltip-arrow::before': {
        background: `#1D1F48`,
        fontSize: '0.875rem',
      },
      '& .MuiTooltip-tooltip': {
        fontFeatureSettings: `'clig' off, 'liga' off`,
        padding: theme.spacing(2),
        width: '20.625rem',
      },
    },

    tooltipIcon: {
      marginLeft: theme.spacing(1),
      fontSize: '0.875rem',
      color: '#4F4F4F',
      transition: 'all 0.2s ease-in-out',
      pointerEvents: 'auto',
      transformOrigin: 'top right',
    },
  }),
);
